// src/lib/translations.ts

export const translations = {
  gameOverview: {
    title: {
      en: "overview",
      ja: "概要",
      ko: "개요",
      th: "ภาพรวม",
      es: "descripción general",
      ru: "обзор",
      vi: "tổng quan",
      kk: "шолу",
      id: "ikhtisar",
      de: "Übersicht"
    },
    whyPlay: {
      en: "Why Play",
      ja: "なぜプレイするのか",
      ko: "왜 플레이해야 하나요",
      th: "ทำไมต้องเล่น",
      es: "Por qué jugar",
      ru: "Почему стоит играть",
      vi: "Tại sao nên chơi",
      kk: "Неге ойнау керек",
      id: "Mengapa bermain",
      de: "Warum spielen"
    }
  },
  gameplayGuide: {
    title: {
      en: "How to play",
      ja: "遊び方",
      ko: "게임 방법",
      th: "วิธีการเล่น",
      es: "Cómo jugar",
      ru: "Как играть",
      vi: "Cách chơi",
      kk: "Қалай ойнау керек",
      id: "Cara bermain",
      de: "Spielanleitung"
    },
    removeBlocks: {
      en: "Cat Chaos Prankster",
      ja: "キャット カオス プランクスター",
      es: "Gato Caos Bromista",
      ko: "캣 카오스 프랭크스터",
      th: "แมววุ่นวายตัวป่วน",
      ru: "Кот-Проказник Хаоса",
      vi: "Mèo Tinh Quái Nghịch Ngợm",
      kk: "Бұзақы Мысық",
      id: "Kucing Kacau Jahil",
      de: "Katzen-Chaos-Schelm"
    }
  },
  scoringSystem: {
    title: {
      en: "How to calculate points",
      ja: "ポイントの計算方法",
      ko: "점수 계산 방법",
      th: "วิธีคำนวณคะแนน",
      es: "Cómo calcular puntos",
      ru: "Как подсчитать очки",
      vi: "Cách tính điểm",
      kk: "Ұпай есептеу әдісі",
      id: "Cara menghitung poin",
      de: "Punkteberechnung"
    },
    basicScore: {
      en: "Basic score",
      ja: "基本スコア",
      ko: "기본 점수",
      th: "คะแนนพื้นฐาน",
      es: "Puntuación básica",
      ru: "Базовые очки",
      vi: "Điểm cơ bản",
      kk: "Негізгі ұпай",
      id: "Skor dasar",
      de: "Grundpunktzahl"
    }
  },
  tutorials: {
    title: {
      en: "Tutorial Videos from Youtube",
      ja: "YouTubeのチュートリアル動画",
      ko: "YouTube 튜토리얼 동영상",
      th: "วิดีโอสอนจาก Youtube",
      es: "Videos tutoriales de Youtube",
      ru: "Обучающие видео с Youtube",
      vi: "Video hướng dẫn từ Youtube",
      kk: "Youtube бейне нұсқаулықтары",
      id: "Video Tutorial dari Youtube",
      de: "Tutorial-Videos von Youtube"
    }
  },
  comments: {
    title: {
      en: "Comments",
      ja: "コメント",
      ko: "댓글",
      th: "ความคิดเห็น",
      es: "Comentarios",
      ru: "Комментарии",
      vi: "Bình luận",
      kk: "Пікірлер",
      id: "Komentar",
      de: "Kommentare"
    },
    placeholders: {
      name: {
        en: 'Your name',
        ja: 'お名前',
        ko: '이름',
        th: 'ชื่อของคุณ',
        es: 'Tu nombre',
        ru: 'Ваше имя',
        vi: 'Tên của bạn',
        kk: 'Сіздің атыңыз',
        id: 'Nama Anda',
        de: 'Ihr Name'
      },
      content: {
        en: 'Write a comment...',
        ja: 'コメントを書く...',
        ko: '댓글을 작성하세요...',
        th: 'เขียนความคิดเห็น...',
        es: 'Escribe un comentario...',
        ru: 'Написать комментарий...',
        vi: 'Viết bình luận...',
        kk: 'Пікір жазыңыз...',
        id: 'Tulis komentar...',
        de: 'Schreiben Sie einen Kommentar...'
      }
    },
    noComments: {
      en: "No comments yet. Be the first to comment!",
      ja: "まだコメントはありません。最初のコメントを投稿しましょう！",
      ko: "아직 댓글이 없습니다. 첫 댓글을 남겨보세요!",
      th: "ยังไม่มีความคิดเห็น เป็นคนแรกที่แสดงความคิดเห็น!",
      es: "Aún no hay comentarios. ¡Sé el primero en comentar!",
      ru: "Пока нет комментариев. Будьте первым, кто прокомментирует!",
      vi: "Chưa có bình luận nào. Hãy là người đầu tiên bình luận!",
      kk: "Әзірше пікірлер жоқ. Бірінші болып пікір қалдырыңыз!",
      id: "Belum ada komentar. Jadilah yang pertama berkomentar!",
      de: "Noch keine Kommentare. Seien Sie der Erste, der kommentiert!"
    },
    sortBy: {
      newest: {
        en: "Newest",
        ja: "最新",
        ko: "최신순",
        th: "ใหม่ล่าสุด", 
        es: "Más recientes",
        ru: "Новейшие",
        vi: "Mới nhất",
        kk: "Ең жаңа",
        id: "Terbaru",
        de: "Neueste"
      },
      oldest: {
        en: "Oldest",
        ja: "最古",
        ko: "오래된순",
        th: "เก่าที่สุด",
        es: "Más antiguos", 
        ru: "Старейшие",
        vi: "Cũ nhất",
        kk: "Ең ескі",
        id: "Terlama",
        de: "Älteste"
      }
    },
    submitButton: {
      en: 'Submit Comment',
      ja: 'コメントを投稿',
      ko: '댓글 작성',
      th: 'ส่งความคิดเห็น',
      es: 'Enviar comentario',
      ru: 'Отправить комментарий',
      vi: 'Gửi bình luận',
      kk: 'Пікір жіберу',
      id: 'Kirim Komentar',
      de: 'Kommentar absenden'
    }
  },
  footer: {
    about: {
      title: {
        en: "About",
        ja: "について",
        ko: "소개",
        th: "เกี่ยวกับ",
        es: "Acerca de",
        ru: "О нас",
        vi: "Giới thiệu",
        kk: "Туралы",
        id: "Tentang",
        de: "Über uns"
      },
      description: {
        en: "Play Cat Chaos: Prankster online free - Become the ultimate feline troublemaker in this hilarious 3D simulation where you create mayhem in Granny house!",
        ja: "「キャット カオス：プランクスター」を無料でプレイ - おばあちゃんの家で大騒ぎを起こす愉快な3Dシミュレーションで、究極のいたずら猫になろう！",
        ko: "캣 카오스: 프랭크스터를 무료로 플레이하세요 - 할머니의 집에서 대소동을 일으키는 이 재미있는 3D 시뮬레이션에서 최고의 장난꾸러기 고양이가 되어보세요!",
        th: "เล่น แมววุ่นวายตัวป่วน ออนไลน์ฟรี - มาเป็นแมวจอมก่อกวนในเกมจำลอง 3 มิติสุดฮาที่คุณจะได้สร้างความวุ่นวายในบ้านคุณยาย!",
        es: "Juega Gato Caos: Bromista gratis en línea - ¡Conviértete en el supremo felino bromista en esta divertida simulación 3D donde crearás caos en la casa de la abuela!",
        ru: "Играйте в Кот-Проказник Хаоса бесплатно онлайн - Станьте главным кошачьим проказником в этом весёлом 3D симуляторе, где вы устраиваете хаос в доме бабушки!",
        vi: "Chơi Mèo Tinh Quái Nghịch Ngợm trực tuyến miễn phí - Trở thành chú mèo phá phách trong trò chơi mô phỏng 3D vui nhộn này, nơi bạn tạo ra sự hỗn loạn trong nhà của bà!",
        kk: "Бұзақы Мысықты онлайн тегін ойнаңыз - Әжейдің үйінде ойран салатын қызықты 3D симуляторда ең үздік тентек мысық болыңыз!",
        id: "Mainkan Kucing Kacau Jahil secara online gratis - Jadilah kucing pembuat onar paling hebat dalam simulasi 3D lucu ini di mana kamu membuat kekacauan di rumah Nenek!",
        de: "Spiele Katzen-Chaos-Schelm kostenlos online - Werde zum ultimativen felinen Unruhestifter in dieser urkomischen 3D-Simulation, in der du Chaos im Haus der Oma verursachst!"
      }
    },
    quickLinks: {
      title: {
        en: "Quick Links",
        ja: "クイックリンク",
        ko: "빠른 링크",
        th: "ลิงก์ด่วน",
        es: "Enlaces rápidos",
        ru: "Быстрые ссылки",
        vi: "Liên kết nhanh", 
        kk: "Жылдам сілтемелер",
        id: "Tautan Cepat",
        de: "Schnelllinks"
      },
      home: {
        en: "Home",
        ja: "ホーム",
        ko: "홈",
        th: "หน้าแรก",
        es: "Inicio",
        ru: "Главная",
        vi: "Trang chủ",
        kk: "Басты бет",
        id: "Beranda",
        de: "Startseite"
      },
      playNow: {
        en: "Play Now",
        ja: "今すぐプレイ",
        ko: "지금 플레이",
        th: "เล่นเลย",
        es: "Jugar ahora",
        ru: "Играть сейчас",
        vi: "Chơi ngay",
        kk: "Қазір ойнау",
        id: "Main Sekarang",
        de: "Jetzt spielen"
      },
      tutorials: {
        en: "Tutorials",
        ja: "チュートリアル",
        ko: "튜토리얼",
        th: "บทเรียน",
        es: "Tutoriales",
        ru: "Учебники",
        vi: "Hướng dẫn",
        kk: "Оқулықтар",
        id: "Tutorial",
        de: "Tutorials"
      },
      popularGames: {
        en: "Popular Games",
        ja: "人気ゲーム",
        ko: "인기 게임",
        th: "เกมยอดนิยม",
        es: "Juegos populares",
        ru: "Популярные игры",
        vi: "Trò chơi phổ biến",
        kk: "Танымал ойындар",
        id: "Game Populer",
        de: "Beliebte Spiele"
      }
    },
    community: {
      title: {
        en: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        th: "ชุมชน",
        es: "Comunidad",
        ru: "Сообщество",
        vi: "Cộng đồng",
        kk: "Қауымдастық", 
        id: "Komunitas",
        de: "Community"
      },
      discord: {
        en: "Discord",
        ja: "Discord",
        ko: "Discord", 
        th: "Discord",
        es: "Discord",
        ru: "Discord",
        vi: "Discord",
        kk: "Discord",
        id: "Discord",
        de: "Discord"
      },
      facebook: {
        en: "Facebook",
        ja: "Facebook",
        ko: "Facebook",
        th: "Facebook",
        es: "Facebook", 
        ru: "Facebook",
        vi: "Facebook",
        kk: "Facebook",
        id: "Facebook",
        de: "Facebook"
      },
      twitter: {
        en: "Twitter",
        ja: "Twitter",
        ko: "Twitter",
        th: "Twitter",
        es: "Twitter",
        ru: "Twitter",
        vi: "Twitter",
        kk: "Twitter",
        id: "Twitter",
        de: "Twitter"
      },
      youtube: {
        en: "YouTube",
        ja: "YouTube",
        ko: "YouTube",
        th: "YouTube",
        es: "YouTube",
        ru: "YouTube",
        vi: "YouTube",
        kk: "YouTube",
        id: "YouTube",
        de: "YouTube"
      }
    },
    contact: {
      title: {
        en: "Contact Us",
        ja: "お問い合わせ",
        ko: "문의하기",
        th: "ติดต่อเรา",
        es: "Contáctenos",
        ru: "Свяжитесь с нами",
        vi: "Liên hệ",
        kk: "Байланыс",
        id: "Hubungi Kami",
        de: "Kontakt"
      },
      email: {
        en: "support@catchaosprankster.com",
        ja: "support@catchaosprankster.com",
        ko: "support@catchaosprankster.com",
        th: "support@catchaosprankster.com",
        es: "support@catchaosprankster.com",
        ru: "support@catchaosprankster.com",
        vi: "support@catchaosprankster.com",
        kk: "support@catchaosprankster.com",
        id: "support@catchaosprankster.com",
        de: "support@catchaosprankster.com"
      },
      address: {
        en: "Game Street, Los Angeles, United States",
        ja: "〒123-4567 ロサンゼルス ゲームストリート",
        ko: "게임 스트리트, 로스앤젤레스, 미국",
        th: "ถนนเกม ลอสแอนเจลิส สหรัฐอเมริกา",
        es: "Calle del Juego, Los Ángeles, Estados Unidos",
        ru: "Улица Игр, Лос-Анджелес, США",
        vi: "Đường Game, Los Angeles, Hoa Kỳ",
        kk: "Гейм көшесі, Лос-Анджелес, АҚШ",
        id: "Jalan Game, Los Angeles, Amerika Serikat",
        de: "Spielstraße, Los Angeles, Vereinigte Staaten"
      }
    },
    links: {
      privacy: {
        en: 'Privacy Policy',
        ja: 'プライバシーポリシー',
        ko: '개인정보 처리방침',
        th: 'นโยบายความเป็นส่วนตัว',
        es: 'Política de privacidad',
        ru: 'Политика конфиденциальности',
        vi: 'Chính sách bảo mật',
        kk: 'Құпиялылық саясаты',
        id: 'Kebijakan Privasi',
        de: 'Datenschutzerklärung'
      },
      terms: {
        en: 'Terms of Service',
        ja: '利用規約',
        ko: '이용약관',
        th: 'ข้อกำหนดการใช้งาน',
        es: 'Términos de servicio',
        ru: 'Условия использования',
        vi: 'Điều khoản dịch vụ',
        kk: 'Қызмет көрсету шарттары',
        id: 'Ketentuan Layanan',
        de: 'Nutzungsbedingungen'
      },
      cookies: {
        en: 'Cookie Policy',
        ja: 'Cookieポリシー',
        ko: '쿠키 정책',
        th: 'นโยบายคุกกี้',
        es: 'Política de cookies',
        ru: 'Политика использования файлов cookie',
        vi: 'Chính sách cookie',
        kk: 'Cookie саясаты',
        id: 'Kebijakan Cookie',
        de: 'Cookie-Richtlinie'
      }
    },
    copyright: {
      en: 'Cat Chaos Prankster. All rights reserved.',
      ja: "キャット カオス プランクスター。全著作権所有。",
      ko: "캣 카오스 프랭크스터. 모든 권리 보유.",
      th: "แมววุ่นวายตัวป่วน สงวนลิขสิทธิ์",
      es: "Gato Caos Bromista. Todos los derechos reservados.",
      ru: "Кот-Проказник Хаоса. Все права защищены.",
      vi: "Mèo Tinh Quái Nghịch Ngợm. Tất cả các quyền được bảo lưu.",
      kk: "Бұзақы Мысық. Барлық құқықтар қорғалған.",
      id: "Kucing Kacau Jahil. Hak cipta dilindungi.",
      de: "Katzen-Chaos-Schelm. Alle Rechte vorbehalten."
    }
  },
  recommendedGames: {
    title: {
      en: 'Recommended Games',
      ja: 'おすすめゲーム',
      ko: '추천 게임',
      th: 'เกมแนะนำ',
      es: 'Juegos Recomendados',
      ru: 'Рекомендуемые игры',
      vi: 'Trò chơi đề xuất',
      kk: 'Ұсынылған ойындар',
      id: 'Game yang Direkomendasikan',
      de: 'Empfohlene Spiele'
    }
  }
} as const;